import { Route, Routes } from 'react-router-dom';
import { FiltersPage } from './FiltersPage';
import { ModifyFilterPage } from './ModifyFilterPage';

export const FilterPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyFilterPage />} />
    <Route path='/:filterID' element={<ModifyFilterPage />} />
    <Route path='*' element={<FiltersPage />} />
  </Routes>
);
